// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dropdown-btn[data-v-1d8b1258]{background:#f2f5fd;border:1px solid #c7d0e9;border-radius:3px;box-sizing:border-box}.dropdown-btn .v-icon[data-v-1d8b1258]{margin-left:1.5rem}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
